// Returns the urgency reference timestamp for sorting.
// Overdue-scheduled orders use scheduled_for; everything else uses created_at.
function getUrgencyMs(order) {
  if (order.scheduled_for) return new Date(order.scheduled_for).getTime();
  return new Date(order.created_at).getTime();
}

// Future-scheduled orders (scheduled_for > now) are not yet urgent.
function isScheduledFuture(order) {
  return !!order.scheduled_for && new Date(order.scheduled_for).getTime() > Date.now();
}

/**
 * Sort active orders by urgency: oldest/most delayed first.
 *
 * Rules:
 *  1. Non-future orders come before future-scheduled orders.
 *  2. Within each group, sort ascending by urgency timestamp (oldest first).
 *     - Scheduled overdue: urgency = scheduled_for
 *     - All others: urgency = created_at
 *  3. Returns a new array — does NOT mutate the input.
 */
export function sortActiveOrdersByUrgency(orders) {
  return [...orders].sort((a, b) => {
    const aFuture = isScheduledFuture(a) ? 1 : 0;
    const bFuture = isScheduledFuture(b) ? 1 : 0;
    if (aFuture !== bFuture) return aFuture - bFuture;
    return getUrgencyMs(a) - getUrgencyMs(b);
  });
}
